var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimpleOutputs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 26C27.4477 26 27 26.4477 27 27C27 27.5523 27.4477 28 28 28H32V32C32 32.5523 32.4477 33 33 33C33.5523 33 34 32.5523 34 32V28H38C38.5523 28 39 27.5523 39 27C39 26.4477 38.5523 26 38 26H34V22C34 21.4477 33.5523 21 33 21C32.4477 21 32 21.4477 32 22V26H28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C17.7909 10 16 11.7909 16 14V16H14C11.7909 16 10 17.7909 10 20V46C10 48.2091 11.7909 50 14 50H40C42.2091 50 44 48.2091 44 46V44H46C48.2091 44 50 42.2091 50 40V14C50 11.7909 48.2091 10 46 10H20ZM46 42C47.1046 42 48 41.1046 48 40V14C48 12.8954 47.1046 12 46 12H20C18.8954 12 18 12.8954 18 14V40C18 41.1046 18.8954 42 20 42H46ZM16 18V40C16 42.2091 17.7909 44 20 44H42V46C42 47.1046 41.1046 48 40 48H14C12.8954 48 12 47.1046 12 46V20C12 18.8954 12.8954 18 14 18H16Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleOutputs);
export default __webpack_public_path__ + "static/media/simple-outputs.41b4ef38.svg";
export { ForwardRef as ReactComponent };